import React from 'react';
import { FixedSizeList as List } from 'react-window';

import Card from './card';

// Column components
const Column = ({ index, style }) => (
  <div
    className="w-full flex flex-wrap items-center font-bold text-lg pr-4"
    style={style}
  >
    <div className="w-2/12">Started at</div>
    <div className="w-2/12">Finished at</div>
    <div className="w-1/12">Status</div>
    <div className="w-3/12">Engine</div>
    <div className="w-2/12 ">Total Entities count</div>
    <div className="w-2/12 ">New Entities count</div>
  </div>
);

const SeedsListColumn = () => {
  const windowWidth = window.innerWidth;
  return (
    <List
      height={70}
      itemCount={1}
      itemSize={70}
      width={windowWidth - 100}
      itemData={[]}
    >
      {Column}
    </List>
  );
};

// Row components
const Row = ({ index, style, data }) => {
  const renderStatusIntent = (status) => {
    switch (status) {
      case 'finished':
        return 'success';
      case 'pending':
        return 'danger';
      case 'started':
        return 'info';
      default:
        return 'info';
    }
  };
  console.log('data in row', data[index]);

  const name = data[index]['name'] || '-';
  const createdAt = data[index]['created_at'] || '-';
  const isActive = data[index]['active'];
  return (
    <div
      className="w-full pr-8 flex flex-wrap items-center font-normal text-base"
      style={style}
    >
      <Card name={name} createdAt={createdAt} isActive={isActive} />
    </div>
  );
};

const data = [
  {
    active: true,
    claimed: true,
    confidence: 100,
    created_at: '2020-05-10 05:52:04 UTC',
    details: null,
    last_modified: null,
    name: 'glendale-laser.info',
    seed: true,
    type: 'Domain',
  },
];
const SeedsListRow = (props) => {
  console.log('props?.data', props?.data);
  const windowWidth = window.innerWidth;
  const parentElementWidth = document.getElementById('settings-renderer')
    .clientWidth;
  const getTableWidth = () => {
    if (parentElementWidth > 1024) {
      return parentElementWidth - 20;
    } else if (parentElementWidth < 1025) {
      return parentElementWidth - 10;
    } else if (parentElementWidth < 769) {
      return parentElementWidth - 10;
    }
  };

  return (
    <React.Fragment>
      <List
        height={1000}
        itemCount={props?.data?.length || 0}
        itemSize={100}
        width={getTableWidth()}
        itemData={props.data}
      >
        {Row}
      </List>
    </React.Fragment>
  );
};

const SeedsListComponent = (props) => {
  return (
    <React.Fragment>
      {/* <SeedsListColumn /> */}

      <SeedsListRow data={props.data} />
    </React.Fragment>
  );
};

const withoutVirtualization = (props) => {
  const renderStatusIntent = (status) => {
    switch (status) {
      case 'finished':
        return 'success';
      case 'pending':
        return 'danger';
      case 'started':
        return 'info';
      default:
        return 'info';
    }
  };

  return (
    <div>
      <div
        className="w-full flex flex-wrap items-center font-bold text-lg pr-4"
        // style={style}
      >
        <div className="w-2/12">Started at</div>
        <div className="w-2/12">Finished at</div>
        <div className="w-1/12">Status</div>
        <div className="w-3/12">Engine</div>
        <div className="w-2/12 ">Total Entities count</div>
        <div className="w-2/12 ">New Entities count</div>
      </div>

      {props.data?.length
        ? props.data.map((item, index) => {
            const statusIntent = `bg-${renderStatusIntent(
              item['status']
            )}-inactive text-${renderStatusIntent(item['status'])}-active`;
            return (
              <React.Fragment key={index}>
                <div
                  className="py-4 w-full flex flex-wrap items-center font-normal text-base"
                  //   style={style}
                >
                  <div className="w-2/12 pr-1">{item['started_at']}</div>
                  <div className="w-2/12 pr-1">{item['finished_at']}</div>
                  <div className="w-1/12 pr-1">
                    <span
                      className={`px-4 py-2 text-sm uppercase font-bold rounded-lg ${statusIntent}`}
                    >
                      {' '}
                      {item['status']}
                    </span>
                  </div>
                  <div className="w-3/12 pr-1">{item['engine']}</div>
                  <div className="w-2/12">100</div>
                  <div className="w-2/12">10</div>
                </div>
              </React.Fragment>
            );
          })
        : null}
    </div>
  );
};

export default SeedsListComponent;
